/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import jwtDecode from 'jwt-decode';
import { routeTable } from 'src/core/utils/routeTable';

/**
 * Implements an interceptor to check on the token expiration.
 */
export const createSessionExpiryInterceptor = (client: AxiosInstance) => {
    const handleRequest = async (request: InternalAxiosRequestConfig) => {
        const authToken = request.headers.Authorization as string;
        if (authToken) {
            try {
                const decodedToken = jwtDecode(authToken) as { exp: number };
                const currentTime = new Date().getTime() / 1000;

                if (currentTime > decodedToken.exp && !window.location.pathname.includes(routeTable.sessionExpiredPage())) {
                    // Deletes the cookies to force login
                    window.location.href = `${window.location.origin}/session_expired`;
                }
            } catch {
                // Fail silently
            }
        }
        return request;
    };

    client.interceptors.request.use(handleRequest);
};
